import { IOS_CAMPAIGN_ID, ANDROID_CAMPAIGN_ID } from 'config';
import URI from 'urijs';
import { openExternalUrl } from './openExternalUrl';

const APP_STORE_REDIRECT_URL = 'http://www.styleseat.com/app';

/**
 * Generates a URL that, if opened, will redirect the user to the appropriate app store
 */
export const generateAppUrl = () => {
  const urlParams = {
    ios_campaign_id: IOS_CAMPAIGN_ID,
    android_campaign_id: ANDROID_CAMPAIGN_ID,
  };

  return URI(APP_STORE_REDIRECT_URL).search(urlParams).toString();
};

/**
 * Directs the user through our automatic app store redirect url.
 */
export const openAppUrl = () => {
  openExternalUrl(generateAppUrl());
};
